(function () {
  if (window.__rsSavedProductsReady) return;
  window.__rsSavedProductsReady = true;

  var storageKey = 'realstil_saved_products_v1';
  var activeOpener = null;
  var uiReady = false;

  var copy = {
    de: { open: 'Gespeicherte Produkte öffnen', close: 'Gespeicherte Produkte schließen', title: 'Gespeichert', empty: 'Du hast noch keine Produkte gespeichert.', view: 'Ansehen', remove: 'Entfernen', save: 'Produkt speichern', saved: 'Produkt gespeichert' },
    en: { open: 'Open saved products', close: 'Close saved products', title: 'Saved', empty: 'You have not saved any products yet.', view: 'View', remove: 'Remove', save: 'Save product', saved: 'Product saved' },
    fr: { open: 'Ouvrir les produits enregistrés', close: 'Fermer les produits enregistrés', title: 'Enregistrés', empty: 'Vous n’avez encore enregistré aucun produit.', view: 'Voir', remove: 'Supprimer', save: 'Enregistrer le produit', saved: 'Produit enregistré' },
    nl: { open: 'Opgeslagen producten openen', close: 'Opgeslagen producten sluiten', title: 'Opgeslagen', empty: 'Je hebt nog geen producten opgeslagen.', view: 'Bekijken', remove: 'Verwijderen', save: 'Product opslaan', saved: 'Product opgeslagen' },
    tr: { open: 'Kaydedilen ürünleri aç', close: 'Kaydedilen ürünleri kapat', title: 'Kaydedilenler', empty: 'Henüz kaydettiğiniz bir ürün yok.', view: 'Görüntüle', remove: 'Kaldır', save: 'Ürünü kaydet', saved: 'Ürün kaydedildi' }
  };

  function language() {
    var value = String(document.documentElement.lang || navigator.language || 'de').toLowerCase().slice(0, 2);
    return copy[value] ? value : 'de';
  }

  function t(key) {
    return copy[language()][key];
  }

  function readSaved() {
    try {
      var value = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (error) {
      return [];
    }
  }

  function writeSaved(items) {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(items.slice(-100)));
      return true;
    } catch (error) {
      return false;
    }
  }

  function isSaved(items, id) {
    return items.some(function (item) {
      return String(item.id) === String(id);
    });
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/\"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function safeUrl(value) {
    var url = String(value || '').trim();
    if (!url) return '#';
    if (url.charAt(0) === '/') return url;
    try {
      var parsed = new URL(url, window.location.origin);
      return parsed.origin === window.location.origin ? parsed.href : '#';
    } catch (error) {
      return '#';
    }
  }

  function heartSvg() {
    return '<svg class="icon" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" focusable="false" role="presentation"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"></path><path d="M12 20.25 4.55 13.16A5.25 5.25 0 0 1 3 9.4 5 5 0 0 1 8 4.4c1.72 0 3.18.82 4 2.1.82-1.28 2.28-2.1 4-2.1a5 5 0 0 1 5 5c0 1.45-.56 2.7-1.55 3.76L12 20.25Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></g></svg>';
  }

  function injectStyles() {
    if (document.getElementById('rs-saved-products-styles')) return;

    var style = document.createElement('style');
    style.id = 'rs-saved-products-styles';
    style.textContent = [
      '.rs-saved-header-link{cursor:pointer;-webkit-tap-highlight-color:transparent}',
      '.rs-saved-header-link:hover{opacity:.72}',
      '.rs-saved-header-link:focus-visible{outline:2px solid currentColor;outline-offset:2px}',
      '.rs-saved-header-link .cart-link__icon{position:relative}',
      '.rs-saved-header-link .cart-link__icon>.icon{width:24px!important;height:24px!important;display:block!important}',
      '.rs-saved-header-link{display:inline-flex;align-items:center;justify-content:center;flex:0 0 24px;min-height:24px}',
      '.rs-saved-header-link .rs-saved-header-count{position:absolute!important;top:-5px!important;right:-5px!important;min-width:16px;height:16px;padding:0 4px;display:inline-flex;align-items:center;justify-content:center;border-radius:20px;background:#111;color:#fff;font-size:10px;font-weight:700;line-height:1}',
      '.rs-saved-header-count:empty{display:none!important}',
      '.rs-saved-overlay{position:fixed;inset:0;z-index:9998;background:rgba(0,0,0,.38);opacity:0;visibility:hidden;transition:opacity .2s ease,visibility .2s ease}',
      '.rs-saved-overlay.is-open{opacity:1;visibility:visible}',
      '.rs-saved-drawer{position:fixed;top:0;right:0;z-index:9999;width:min(420px,100vw);height:100dvh;display:flex;flex-direction:column;background:#fff;color:#111;transform:translate3d(100%,0,0);transition:transform .26s cubic-bezier(.22,.61,.36,1);box-shadow:-10px 0 30px rgba(0,0,0,.10)}',
      '.rs-saved-drawer.is-open{transform:translate3d(0,0,0)}',
      '.rs-saved-drawer__header{min-height:70px;padding:0 20px;display:flex;align-items:center;justify-content:space-between;border-bottom:1px solid #e9e9e9}',
      '.rs-saved-drawer__title{margin:0;font:inherit;font-size:16px;font-weight:500;letter-spacing:.01em}',
      '.rs-saved-drawer__close{appearance:none;-webkit-appearance:none;width:40px;height:40px;padding:0;display:grid;place-items:center;border:0;background:transparent;color:#111;cursor:pointer}',
      '.rs-saved-drawer__close svg{width:22px;height:22px;fill:none;stroke:currentColor;stroke-width:1.5;stroke-linecap:round}',
      '.rs-saved-drawer__body{flex:1;overflow:auto;-webkit-overflow-scrolling:touch;padding:0 20px 24px}',
      '.rs-saved-empty{margin:0;padding:38px 0;color:#666;font-size:13px;line-height:1.6}',
      '.rs-saved-item{display:grid;grid-template-columns:92px minmax(0,1fr);gap:14px;padding:20px 0;border-bottom:1px solid #ececec}',
      '.rs-saved-item__image{display:block;width:92px;aspect-ratio:4/5;object-fit:cover;background:#f4f4f4}',
      '.rs-saved-item__info{min-width:0;display:flex;flex-direction:column}',
      '.rs-saved-item__title{margin:0 0 5px;color:#111;font-size:13px;line-height:1.35;font-weight:500;text-decoration:none}',
      '.rs-saved-item__price{margin:0 0 14px;color:#111;font-size:13px}',
      '.rs-saved-item__actions{margin-top:auto;display:flex;align-items:center;gap:16px}',
      '.rs-saved-item__view,.rs-saved-item__remove{font:inherit;font-size:12px;color:#111;text-decoration:underline;text-underline-offset:3px}',
      '.rs-saved-item__remove{appearance:none;-webkit-appearance:none;padding:0;border:0;background:transparent;cursor:pointer}',
      'body.rs-saved-drawer-open{overflow:hidden}',
      '@media(max-width:767px){.rs-saved-drawer{width:100vw}.rs-saved-drawer__header{min-height:64px;padding-inline:16px}.rs-saved-drawer__body{padding-inline:16px}}',
      '@media(prefers-reduced-motion:reduce){.rs-saved-overlay,.rs-saved-drawer{transition:none}}'
    ].join('');
    document.head.appendChild(style);
  }

  function updateButton(button, active) {
    var saveLabel = button.dataset.rsAriaSave || t('save');
    var savedLabel = button.dataset.rsAriaSaved || t('saved');
    var status = button.querySelector('[data-rs-save-status]');

    button.classList.toggle('is-saved', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', active ? savedLabel : saveLabel);
    if (status) status.textContent = active ? savedLabel : saveLabel;
  }

  function updateProductButtons(id, active) {
    document.querySelectorAll('[data-rs-save-product]').forEach(function (button) {
      if (String(button.dataset.rsSaveProduct) === String(id)) updateButton(button, active);
    });
  }

  function initialiseButtons(scope) {
    var items = readSaved();
    (scope || document).querySelectorAll('[data-rs-save-product]').forEach(function (button) {
      updateButton(button, isSaved(items, button.dataset.rsSaveProduct));
    });
  }

  function ensureHeaderButton() {
    var existing = document.querySelector('[data-rs-saved-toggle]');
    if (existing) return existing;

    var cart = document.querySelector('.logo-area__right__inner .cart-link');
    if (!cart || !cart.parentNode) return null;

    var link = document.createElement('a');
    link.href = '#';
    link.className = 'rs-saved-header-link';
    link.setAttribute('data-rs-saved-toggle', '');
    link.setAttribute('role', 'button');
    link.setAttribute('aria-label', t('open'));
    link.innerHTML = '<span class="cart-link__icon">' + heartSvg() + '<span class="cart-link__count rs-saved-header-count"></span></span>';
    cart.parentNode.insertBefore(link, cart);

    if (window.theme && typeof window.theme.inlineNavigationCheck === 'function') {
      window.requestAnimationFrame(function () {
        window.theme.inlineNavigationCheck();
      });
    }

    return link;
  }

  function updateHeaderCount(items) {
    var headerLink = ensureHeaderButton();
    if (!headerLink) return;

    var count = Array.isArray(items) ? items.length : readSaved().length;
    var countNode = headerLink.querySelector('.rs-saved-header-count');
    if (countNode) countNode.textContent = count > 0 ? String(count) : '';
    headerLink.setAttribute('aria-label', t('open') + (count > 0 ? ' (' + count + ')' : ''));
  }

  // Keep the custom bookmark in the header after AJAX cart updates replace header content.
  var rsObservedHeader = null;
  var rsHeaderObserver = null;
  function watchSavedHeader() {
    if (!window.MutationObserver) return;
    var header = document.querySelector('#pageheader') || document.querySelector('.section-header');
    if (!header || rsObservedHeader === header) return;
    if (rsHeaderObserver) rsHeaderObserver.disconnect();
    rsObservedHeader = header;
    rsHeaderObserver = new MutationObserver(function () {
      if (!header.isConnected) return;
      if (!header.querySelector('[data-rs-saved-toggle]') &&
          header.querySelector('.logo-area__right__inner a.cart-link[href*="/cart"]')) {
        window.requestAnimationFrame(function () { updateHeaderCount(); });
      }
    });
    rsHeaderObserver.observe(header, { childList: true, subtree: true });
  }
  function restoreSavedHeader() {
    window.requestAnimationFrame(function () {
      updateHeaderCount();
      watchSavedHeader();
    });
  }

  function ensureDrawer() {
    var existing = document.querySelector('[data-rs-saved-drawer]');
    if (existing) return existing;

    var overlay = document.createElement('div');
    overlay.className = 'rs-saved-overlay';
    overlay.setAttribute('data-rs-saved-overlay', '');

    var drawer = document.createElement('aside');
    drawer.className = 'rs-saved-drawer';
    drawer.setAttribute('data-rs-saved-drawer', '');
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('aria-label', t('title'));
    drawer.innerHTML =
      '<div class="rs-saved-drawer__header">' +
        '<h2 class="rs-saved-drawer__title">' + escapeHtml(t('title')) + '</h2>' +
        '<button type="button" class="rs-saved-drawer__close" data-rs-saved-close aria-label="' + escapeHtml(t('close')) + '">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5 5 19"></path></svg>' +
        '</button>' +
      '</div>' +
      '<div class="rs-saved-drawer__body" data-rs-saved-list></div>';

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);
    return drawer;
  }

  function renderSaved() {
    var items = readSaved();
    updateHeaderCount(items);

    var list = document.querySelector('[data-rs-saved-list]');
    if (!list) return;

    if (!items.length) {
      list.innerHTML = '<p class="rs-saved-empty">' + escapeHtml(t('empty')) + '</p>';
      return;
    }

    list.innerHTML = items.slice().reverse().map(function (item) {
      var url = safeUrl(item.url || (item.handle ? '/products/' + item.handle : '#'));
      var image = item.image
        ? '<a href="' + escapeHtml(url) + '"><img class="rs-saved-item__image" src="' + escapeHtml(item.image) + '" alt="" loading="lazy" decoding="async"></a>'
        : '<a class="rs-saved-item__image" href="' + escapeHtml(url) + '" aria-label="' + escapeHtml(item.title) + '"></a>';

      return '<article class="rs-saved-item" data-rs-saved-item="' + escapeHtml(item.id) + '">' +
        image +
        '<div class="rs-saved-item__info">' +
          '<a class="rs-saved-item__title" href="' + escapeHtml(url) + '">' + escapeHtml(item.title) + '</a>' +
          '<p class="rs-saved-item__price">' + escapeHtml(item.price) + '</p>' +
          '<div class="rs-saved-item__actions">' +
            '<a class="rs-saved-item__view" href="' + escapeHtml(url) + '">' + escapeHtml(t('view')) + '</a>' +
            '<button type="button" class="rs-saved-item__remove" data-rs-saved-remove="' + escapeHtml(item.id) + '">' + escapeHtml(t('remove')) + '</button>' +
          '</div>' +
        '</div>' +
      '</article>';
    }).join('');
  }

  function openDrawer(opener) {
    var drawer = ensureDrawer();
    var overlay = document.querySelector('[data-rs-saved-overlay]');
    activeOpener = opener || document.activeElement;
    renderSaved();

    window.requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add('is-open');
      document.body.classList.add('rs-saved-drawer-open');
      var close = drawer.querySelector('[data-rs-saved-close]');
      if (close) close.focus({ preventScroll: true });
    });
  }

  function closeDrawer() {
    var drawer = document.querySelector('[data-rs-saved-drawer]');
    var overlay = document.querySelector('[data-rs-saved-overlay]');
    if (!drawer) return;

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('rs-saved-drawer-open');

    if (activeOpener && typeof activeOpener.focus === 'function') {
      activeOpener.focus({ preventScroll: true });
    }
    activeOpener = null;
  }

  function toggleSavedProduct(button) {
    var items = readSaved();
    var id = button.dataset.rsSaveProduct;
    var index = items.findIndex(function (item) {
      return String(item.id) === String(id);
    });
    var active = false;

    if (index > -1) {
      items.splice(index, 1);
    } else {
      items.push({
        id: id,
        handle: button.dataset.rsProductHandle || '',
        url: button.dataset.rsProductUrl || '',
        title: button.dataset.rsProductTitle || '',
        image: button.dataset.rsProductImage || '',
        price: button.dataset.rsProductPrice || '',
        savedAt: new Date().toISOString()
      });
      active = true;
    }

    if (writeSaved(items)) {
      updateProductButtons(id, active);
      renderSaved();
    }
  }

  function initialiseUI() {
    if (uiReady) return;
    injectStyles();
    ensureHeaderButton();
    watchSavedHeader();
    initialiseButtons(document);
    renderSaved();
    uiReady = true;
  }

  document.addEventListener('click', function (event) {
    var saveButton = event.target.closest('[data-rs-save-product]');
    if (saveButton) {
      event.preventDefault();
      toggleSavedProduct(saveButton);
      return;
    }

    var toggle = event.target.closest('[data-rs-saved-toggle]');
    if (toggle) {
      event.preventDefault();
      openDrawer(toggle);
      return;
    }

    var remove = event.target.closest('[data-rs-saved-remove]');
    if (remove) {
      event.preventDefault();
      var id = remove.getAttribute('data-rs-saved-remove');
      var items = readSaved().filter(function (item) {
        return String(item.id) !== String(id);
      });
      if (writeSaved(items)) {
        updateProductButtons(id, false);
        renderSaved();
      }
      return;
    }

    if (event.target.closest('[data-rs-saved-close]') || event.target.closest('[data-rs-saved-overlay]')) {
      event.preventDefault();
      closeDrawer();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });

  document.addEventListener('shopify:section:load', function (event) {
    injectStyles();
    ensureHeaderButton();
    watchSavedHeader();
    initialiseButtons(event.target);
    renderSaved();
  });

  // Theme cart merges can recreate the header; keep the bookmark persistent and separate from cart links.
  ['on:cart:after-merge', 'on:cart:add', 'on:cart:change', 'on:cart-drawer:after-open'].forEach(function (name) {
    document.addEventListener(name, restoreSavedHeader);
  });
  window.addEventListener('pageshow', restoreSavedHeader);

  window.addEventListener('storage', function (event) {
    if (event.key === storageKey) {
      initialiseButtons(document);
      renderSaved();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseUI, { once: true });
  } else {
    initialiseUI();
  }
})();
